import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from '../../../core/utils/utils.service';
import {Subscription} from 'rxjs';
import {CommandesClientService} from "../../../core/services/entities/commandes-client.service";
import ViewCommandesEffectifsDTO from "../../../core/dtos/planification/views/view-commandes-effectifs-dto";
import PlcRepasEffectifsCommandesClientDTO
  from "../../../core/dtos/planification/plc-repas-effectifs-commandes-client-dto";
import RepasPlcEffectifsCommandesClientDTO
  from "../../../core/dtos/planification/repas-plc-effectifs-commandes-client-dto";
import {StartPointCommandesClientsEnum} from "../../../core/enums/start-point-commandes-clients-enum";
import DatesDetailsFromMenuDTO from "../../../core/dtos/planification/dates-details-from-menu-dto";
import ViewEffectifsByPrestationPlcRepasDTO
  from "../../../core/dtos/planification/views/view-effectifs-by-prestation-plc-repas-dto";
import ViewEffectifsByPrestationRepasPlcDTO
  from "../../../core/dtos/planification/views/view-effectifs-by-prestation-repas-plc-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {ToastService} from "../../../core/services/technique/toast.service";
import {TypeEffectifEnum} from "../../../core/enums/type-effectif-enum";

@Component({
  selector: 'yo-prestations-semaine',
  templateUrl: './prestations-semaine.component.html',
  styleUrls: ['./prestations-semaine.component.scss'],

})
export class PrestationsSemaineComponent implements OnInit, OnDestroy {

  @Input("cols") cols: Date[];
  @Input("endPoint") endPoint: StartPointCommandesClientsEnum;
  @Input("typeEffectif") typeEffectif: TypeEffectifEnum;

  subViewCommandesEffectif: Subscription;
  subLoadingView: Subscription;
  subDatesDetailsFromMenu: Subscription;
  subEndPoint: Subscription;

  datesDetailsFromMenu: DatesDetailsFromMenuDTO;
  repas: RepasPlcEffectifsCommandesClientDTO[] = [];
  pointsDeLivraison: PlcRepasEffectifsCommandesClientDTO[] = [];
  isLoadingView: boolean = false;

  constructor(public utils: UtilsService,
              private commandesClientSvc: CommandesClientService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.viewCommandesEffectifSubscription();
    this.loadingViewSubscription();
    this.datesDetailsFromMenuSubscription();
    this.endPointSubscription();
  }

  viewCommandesEffectifSubscription = () => {
    this.subViewCommandesEffectif = this.commandesClientSvc.viewCommandesEffectif$.subscribe((response: ViewCommandesEffectifsDTO) => {
      let messageToast: string = `Mise à jour des données réussie avec succès !`;
      let messageSeverity: string = MSG_SEVERITY.SUCCESS;
      this.pointsDeLivraison = [];
      this.repas = [];

      if (response) {
        if (this.isPointDeLivraisonFirst()) {
          this.pointsDeLivraison = (response as ViewEffectifsByPrestationPlcRepasDTO).pointsLivraison;
        } else {
          this.repas = (response as ViewEffectifsByPrestationRepasPlcDTO).repas;
        }

      } else {
        messageSeverity = MSG_SEVERITY.WARNING;
        messageToast = `Aucun résultat à afficher pour votre sélection`;
      }
      this.commandesClientSvc.announceLoadingView(false);
      this.toastSvc.displayToast(MSG_KEY.ROOT, messageSeverity, messageToast);
    })
  }

  loadingViewSubscription = () => {
    this.subLoadingView = this.commandesClientSvc.loadingView$
      .subscribe((isLoading: boolean) => this.isLoadingView = isLoading);
  }

  datesDetailsFromMenuSubscription = () => {
    this.subDatesDetailsFromMenu = this.commandesClientSvc.datesDetailsFromMenu$
      .subscribe((datesDetailsFromMenu: DatesDetailsFromMenuDTO) => this.datesDetailsFromMenu = datesDetailsFromMenu);
  }

  endPointSubscription = () => {
    this.subEndPoint = this.commandesClientSvc.endPointUpdated$
      .subscribe((endPoint: StartPointCommandesClientsEnum) => this.endPoint = endPoint);
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subViewCommandesEffectif);
    this.utils.unsubscribe(this.subLoadingView);
    this.utils.unsubscribe(this.subDatesDetailsFromMenu);
    this.utils.unsubscribe(this.subEndPoint);
  }

  canDisplayGrille = () => (this.repas?.length || this.pointsDeLivraison?.length) && this.cols?.length;

  isPointDeLivraisonFirst = () => this.endPoint === StartPointCommandesClientsEnum.PLC;
}
